var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon-hamburger",attrs:{"xmlns":"http://www.w3.org/2000/svg","version":"1.1","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"fill":"none","stroke":"currentcolor","stroke-width":"2","d":"M0 1h20M0 10h20M0 19h20"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }